import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchHook from "../../../../Api/FetchHooks";
import TransactionTable from "../../../../Components/TransactionTable";
import PageLoader from "../../../../Components/PageLoader";
import { useSelector } from "react-redux";
import UseServerTable from "../../../../Hooks/UseServerTable";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import AlertComponent from "../../../../Components/AlertComponent";

const UserLoanTransactions = ({ loan, user }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [_loan, _setLoan] = useState(loan || location.state.loan);
  const [_user, _setUser] = useState(user || loggedInUser);
  const [data, setData] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchData = useCallback(async () => {
  //   await request({
  //     url: `transaction?filter_value=${_user.id}&loan_id=${_loan.id}&loan_request_id=${_loan.request_id}&role=customer`,
  //   });
  // }, [_user, _loan]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `transaction?filter_value=${_user.id}&loan_id=${_loan.id}&loan_request_id=${_loan.request_id}&role=customer`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  // const columns = [
  //   {
  //     field: "transaction_id",
  //     headerName: "Transaction Id",
  //     width: 150,
  //   },
  //   {
  //     field: "account_number",
  //     headerName: "Account Number",
  //     width: 150,
  //   },
  //   // {
  //   //   field: "source_transaction_id",
  //   //   headerName: "Transaction Id",
  //   //   width: 150,
  //   // },
  //   // {
  //   //   field: "dr_cr_pair_id",
  //   //   headerName: "dr_cr_pair_id",
  //   //   width: 150,
  //   // },
  //   // {
  //   //   field: "loan_id",
  //   //   headerName: "Loan Id",
  //   //   width: 150,
  //   // },
  //   // {
  //   //   field: "global_request_id",
  //   //   headerName: "Global request Id",
  //   //   width: 150,
  //   // },
  //   // {
  //   //   field: "balance_before",
  //   //   headerName: "Balance before",
  //   //   width: 150,
  //   // },
  //   {
  //     field: "debit",
  //     headerName: "Debit (money out)",
  //     width: 150,
  //   },
  //   {
  //     field: "credit",
  //     headerName: "Credit (money in)",
  //     width: 150,
  //   },
  //   {
  //     field: "balance_after",
  //     headerName: "Balance",
  //     width: 150,
  //   },
  //   {
  //     field: "type",
  //     headerName: "Type",
  //     width: 150,
  //   },
  //   {
  //     field: "description",
  //     headerName: "Description",
  //     width: 300,
  //   },
  //   {
  //     field: "transaction_status",
  //     headerName: "Transaction status",
  //     width: 300,
  //   },
  //   // {
  //   //   field: "transaction_timestamp",
  //   //   headerName: "Transaction Timestamp",
  //   //   width: 300,
  //   //   valueFormatter: (params) =>
  //   //     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
  //   // },
  //   {
  //     field: "transaction_settlement_time",
  //     headerName: "Transaction Settlement Time",
  //     width: 300,
  //     valueFormatter: (params) =>
  //       moment(params?.value).format("DD/MM/YYYY hh:mm A"),
  //   },
  // ];

  const extraColumns = [
    {
      field: "account_number",
      headerName: "Account Number",
      width: 150,
    },
    {
      field: "type",
      headerName: "Type",
      width: 150,
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction Settlement Time",
      width: 250,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
  ];

  return (
    <Box>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <Typography variant="h6">
              User statements (Loan_id: {location.state.loan.id})
            </Typography>
          }
        />
        <CardContent>
          {data && data.length > 0 ? (
            <TransactionTable
              data={data}
              extraColumns={extraColumns}
              sortModel={[
                {
                  field: "transaction_settlement_time",
                  sort: "desc",
                },
              ]}
              {...gridProps}
            />
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="You have no transactions!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserLoanTransactions;
